export default array => {
    return array.filter((value, index) => {
        return array.indexOf(value) === index
    })
}
